module.exports = __webpack_public_path__ + "static/media/mockup-presentation.7e528082.png";